import { foundationRadioStyles } from '@genesislcap/foundation-ui';
import { css } from '@microsoft/fast-element';
import { PrimaryRapidColorHEX } from '../_common';
export const zeroRadioStyles = (context, definition) => css `
  ${foundationRadioStyles(context, definition)}
  :host {
    --primary-gradient-angle: -113.5deg;
  }

  :host .control {
    background: transparent;
  }

  :host([aria-checked='true']) .control {
    background: transparent;
    border: calc(var(--stroke-width) * 1px) solid var(--neutral-stroke-rest);
  }

  :host(:not([disabled])) .control:hover {
    background: transparent;
  }

  :host([aria-checked='true']:not([disabled])) .control:hover {
    background: transparent;
    border: calc(var(--stroke-width) * 1px) solid var(--neutral-stroke-hover);
  }

  .checked-indicator,
  :host([aria-checked='true']:not([disabled])) .control:hover .checked-indicator {
    background: linear-gradient(
      var(--primary-gradient-angle),
      ${PrimaryRapidColorHEX.blue},
      ${PrimaryRapidColorHEX.purple}
    );
  }
`;
